import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import { jsxs as e, jsx as t } from "react/jsx-runtime";
import { Body as r } from "@vds-core/typography";
import { calculateRem as o, withVDSManager as s, generateUUID as a, getNodeText as i } from "@vds-core/utilities";
import { ColorTokens as n } from "@vds-tokens/color";
import { LayoutTokens as d } from "@vds-tokens/layout";
import { Component as c } from "react";
import l, { css as p } from "styled-components";
import h from "./CheckboxError.js";
import u from "./CheckboxIcon.js";
import m from "./CheckboxLabel.js";
import f from "../utils/showError.js";
var v = o(2),
  b = o(d.space["1X"].value),
  k = l.div.withConfig({
    displayName: "CheckboxWrapper",
    componentId: "VDS__sc-17oubd8-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  max-width: 100%;\n  width: ", ";\n"])), function (_ref) {
    var e = _ref.width;
    return e;
  }),
  w = l.div.withConfig({
    displayName: "CheckWrapper",
    componentId: "VDS__sc-17oubd8-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: ", ";\n  position: relative;\n  top: 0;\n  left: 0;\n  width: ", ";\n  display: flex;\n  flex-shrink: 0;\n  ", "\n"])), o(20), o(20), function (_ref2) {
    var e = _ref2.$hasLabel;
    return e && p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      margin-right: ", ";\n    "])), o(d.space["3X"].value));
  }),
  y = l.span.withConfig({
    displayName: "ChildWrapper",
    componentId: "VDS__sc-17oubd8-2"
  })(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top: 0;\n"]))),
  g = l.span.withConfig({
    displayName: "LabelWrapper",
    componentId: "VDS__sc-17oubd8-3"
  })(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n  padding-bottom: ", ";\n"])), o(d.space["1X"].value)),
  x = l.input.withConfig({
    displayName: "StyledInput",
    componentId: "VDS__sc-17oubd8-4"
  })(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  pointer-events: ", "; // pointer-events: auto; To ensure proper functions when used on TileContainer\n"])), function (_ref3) {
    var e = _ref3.disabled;
    return e ? "none" : "auto";
  });
var C = /*#__PURE__*/function (_c) {
  _inherits(C, _c);
  function C(e) {
    var _this;
    _classCallCheck(this, C);
    var t;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(C).call(this, e)), t = _assertThisInitialized(_assertThisInitialized(_this)), _this.handleSelect = function (e) {
      var r, o;
      27 !== e.keyCode && e.stopPropagation();
      var _t$state = t.state,
        s = _t$state.hovered,
        a = _t$state.showFocus,
        i = e.keyCode,
        n = 13 === i || 32 === i;
      if (n && (e.preventDefault(), t.props.onKeyDown && t.props.onKeyDown(e)), (i && n || !i) && (s && a && t.setState({
        showFocus: !1
      }), i && n && (e.target.checked = !t.state.selected), null === (o = (r = t.props).onChange) || void 0 === o || o.call(r, e, {
        name: t.props.name,
        value: t.props.value,
        selected: !t.state.selected,
        index: t.props.index
      }), t.isControlled || t.setState(function (e) {
        return {
          selected: !e.selected
        };
      }), "change" === t.props.errorEvent)) {
        f(e, t);
      }
    }, _this._onBlur = function (e) {
      if ("blur" === t.props.errorEvent) {
        f(e, t);
      }
    }, _this._addHover = function (e) {
      t.state.hovered || t.setState({
        hovered: !0
      });
    }, _this._removeHover = function (e) {
      return t.setState({
        hovered: !1
      });
    }, _this._onFocus = function (e) {
      var _t$props = t.props,
        r = _t$props.showFocus,
        o = _t$props.hovered;
      o || r ? r && t.setState({
        showFocus: !1
      }) : t.setState({
        showFocus: !0
      });
    }, _this.state = {
      selected: _this.props.selected || !1,
      showFocus: !0,
      error: !0 === _this.props.error,
      hovered: !1
    };
    return _this;
  }
  _createClass(C, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isControlled = this.props.hasOwnProperty("selected");
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      e && e.selected !== this.props.selected && this.setState(function () {
        return {
          selected: !e.selected
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        o = _this$props.className,
        s = _this$props.required,
        d = _this$props.surface,
        c = _this$props.children,
        l = _this$props.label,
        p = _this$props.customLabel,
        f = _this$props.tabIndex,
        v = _this$props.disabled,
        b = _this$props.error,
        C = _this$props.errorText,
        _ = _this$props.name,
        S = _this$props.value,
        D = _this$props.width,
        F = _this$props.id,
        $ = _this$props.inputId,
        I = _this$props.inputRef,
        L = _this$props.borderRadius,
        N = _this$props.focusBorderRadius,
        B = _this$props["data-analyticstrack"],
        E = _this$props["data-track"],
        R = _this$props["data-track-ignore"],
        T = _this$props["data-clickstream"],
        j = _this$props.ariaLabel,
        V = _this$props.ariaDescribedBy,
        _this$state = this.state,
        H = _this$state.selected,
        M = _this$state.error,
        P = M || "boolean" == typeof b && b,
        W = $ || a(),
        q = C || "";
      P && (C || console.error("Error Text for Checkbox MUST be provided"));
      var K = "dark" === d ? n.elements.primary.ondark.value : n.elements.primary.onlight.value,
        X = "dark" === d ? n.interactive.disabled.ondark.value : n.interactive.disabled.onlight.value;
      return e(k, {
        width: D,
        id: F,
        children: [e(m, {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          className: o,
          disabled: v,
          error: P,
          htmlFor: p ? null : W,
          color: v ? X : K,
          onMouseEnter: this._addHover,
          onMouseLeave: this._removeHover,
          showFocus: this.state.showFocus,
          focusBorderRadius: N,
          children: [e(w, {
            $hasLabel: !!l || !!c,
            children: [t(x, {
              checked: H,
              $required: s,
              "data-testid": "test-input",
              disabled: v,
              id: W,
              name: _,
              onChange: this.handleSelect,
              onKeyDown: this.handleSelect,
              onBlur: this._onBlur,
              tabIndex: f || 0,
              ref: I,
              type: "checkbox",
              value: S,
              "aria-describedby": V,
              "aria-label": j || (l ? "".concat(l, " ").concat(i(c)) : i(c)),
              "data-clickstream": T,
              "data-analyticstrack": B,
              "data-track": E,
              "data-track-ignore": R,
              onFocus: this._onFocus
            }), t(u, {
              disabled: v,
              error: P,
              selected: H,
              hovered: this.state.hovered,
              surface: d,
              borderRadius: L
            })]
          }), e(y, {
            "data-testid": "test-child-wrapper",
            children: [l && t(g, {
              "aria-hidden": !0,
              children: t(r, {
                size: "large",
                tabIndex: -1,
                bold: !0,
                color: v ? X : K,
                children: l
              })
            }), t("div", {
              "aria-hidden": "string" == typeof c,
              children: c
            })]
          })]
        }), P && !v && t(h, {
          errorText: q,
          color: K
        })]
      });
    }
  }]);
  return C;
}(c);
C.defaultProps = {
  children: "",
  required: !0,
  className: "",
  surface: "light",
  disabled: !1,
  customLabel: !1,
  error: void 0,
  errorEvent: "blur",
  onChange: function onChange() {
    return {};
  },
  width: "100%",
  borderRadius: v,
  focusBorderRadius: b
};
var _ = s(C);
export { _ as default };